import { Skeleton, SpaceBetween, tk } from '@sunwebgroup/ui-components'
import { styled } from 'styled-components'
import { Card } from '../../../../../../../common/components/Card'

const ProductNameSkeleton = styled(Skeleton)`
  width: 211px;
  height: ${tk('font_size_xl')};
`

const StarsSkeleton = styled(Skeleton)`
  width: 75px;
  height: ${tk('font_size_sm')};
`

const LocationsSkeleton = styled(Skeleton)`
  width: 173px;
  height: ${tk('font_size_sm')};
`

const ImageCarouselSkeleton = styled(Skeleton)`
  width: 100%;
  height: 300px;

  @media ${tk('mq_tablet')} {
    height: 320px;
  }
`

const UserRatingSkeleton = styled(Skeleton)`
  width: 65px;
  height: ${tk('font_size_3xl')};
  border-radius: ${tk('radius_rounded')};
`

const USPListSkeleton = styled(SpaceBetween)``

const USPItemSkeleton = styled(Skeleton)`
  width: 258px;
  height: ${tk('font_size_sm')};
`

const PackageBlockAndPriceSkeleton = styled(SpaceBetween)``

const PackageBlockFirstRowSkeleton = styled(Skeleton)`
  width: 135px;
  height: ${tk('font_size_sm')};
`

const PackageBlockSecondRowSkeleton = styled(SpaceBetween)`
  width: 135px;
  height: ${tk('font_size_sm')};

  > * {
    width: 100%;
  }
`

const PriceSkeleton = styled(Skeleton)`
  width: 122px;
  height: ${tk('font_size_3xl')};
`

const TextsWrapper = styled(SpaceBetween)`
  flex: 1;

  > * {
    margin-bottom: ${tk('spacing_sm')};
  }

  > *:last-child {
    margin-bottom: 0;
  }
`

const PackageBlockSkeleton = styled(SpaceBetween)`
  align-content: flex-end;
  align-self: flex-end;
`

const PriceBoxSkeleton = styled.div``

const CardSkeleton = styled(Card)`
  @media ${tk('mq_tablet')} {
    display: flex;

    ${ImageCarouselSkeleton} {
      max-width: 255px;
    }

    ${PackageBlockAndPriceSkeleton} {
      position: relative;
    }

    ${PriceBoxSkeleton} {
      position: absolute;
      bottom: 0;
      right: 0;
    }

    ${USPListSkeleton} {
      max-width: 75%;
    }
  }

  @media ${tk('mq_desktop_sm')} {
    ${ImageCarouselSkeleton} {
      max-width: 375px;
    }
  }
`

/**
 * @deprecated This file is deprecated and will be removed in the future.
 * TODO: To be deleted when FF ACTIVATE_UDS_SEARCH_PRODUCT_CARD is deleted.
 */
export function ProductCardLoading(): JSX.Element {
  return (
    <CardSkeleton>
      <ImageCarouselSkeleton />
      <TextsWrapper direction="y" spacing={tk('spacing_lg')} padding={tk('spacing_lg')} justifyContent="space-between">
        <SpaceBetween direction="y" spacing={tk('spacing_lg')}>
          <SpaceBetween direction="y" spacing={tk('spacing_xs')}>
            <SpaceBetween direction="x" justifyContent="space-between">
              <StarsSkeleton />
              <UserRatingSkeleton />
            </SpaceBetween>
            <SpaceBetween direction="x" spacing={tk('spacing_xs')} justifyContent="space-between">
              <SpaceBetween direction="y" spacing={tk('spacing_xs')}>
                <ProductNameSkeleton />
                <LocationsSkeleton />
              </SpaceBetween>
            </SpaceBetween>
          </SpaceBetween>
          <USPListSkeleton direction="y" spacing={tk('spacing_xs')}>
            <USPItemSkeleton />
            <USPItemSkeleton />
            <USPItemSkeleton />
          </USPListSkeleton>
        </SpaceBetween>
        <PackageBlockAndPriceSkeleton direction="x" spacing={tk('spacing_sm')} justifyContent="space-between">
          <PackageBlockSkeleton direction="y" spacing={tk('spacing_2xs')}>
            <PackageBlockFirstRowSkeleton />
            <PackageBlockSecondRowSkeleton direction="x" spacing={tk('spacing_2xs')} justifyContent="space-between">
              <Skeleton />
              <Skeleton />
            </PackageBlockSecondRowSkeleton>
          </PackageBlockSkeleton>
          <PriceBoxSkeleton>
            <SpaceBetween direction="y" spacing={tk('spacing_sm')} justifyContent="space-between" alignItems="flex-end">
              <PackageBlockFirstRowSkeleton />
              <PriceSkeleton />
            </SpaceBetween>
          </PriceBoxSkeleton>
        </PackageBlockAndPriceSkeleton>
      </TextsWrapper>
    </CardSkeleton>
  )
}

ProductCardLoading.displayName = 'ProductCardLoading'
